import HistoryDatePicker from '@/components/history/HistoryDatePicker';
import { memo } from 'react';
import { WeekRange } from '../types';

interface WeeklyHeaderProps {
  totalIncome: number;
  weekRange: WeekRange;
  date: Date;
  onDateChange: (date: Date) => void;
}

const WeeklyHeader = memo(({ totalIncome, weekRange, date, onDateChange }: WeeklyHeaderProps) => {
  return (
    <div className="flex sm:flex-row flex-col justify-between items-center mb-6">
      <div>
        <h2 className="text-2xl font-bold">
          Total:{' '}
          {totalIncome.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </h2>
      </div>
      <div className="flex gap-2 items-center">
        <div className="text-xs p-2 rounded-lg border border-gray-200">
          {weekRange.start} - {weekRange.end}
        </div>
        <HistoryDatePicker selected={date} onChange={onDateChange} />
      </div>
    </div>
  );
});

WeeklyHeader.displayName = 'WeeklyHeader';
export default WeeklyHeader;
